/**
 * US-specific ambles for SimpleBusiness US
 */
export const simplybusinessUsAmbles: Record<string, string> = {
  // Add US-specific ambles here
};
